import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ThresholdFormType } from '../../modules/clientModule/types';

export interface ThresholdFormsState {
  forms: ThresholdFormType[];
  deleteCandidate: ThresholdFormType;
  selectedForm: ThresholdFormType;
  saveIsDisabled: boolean;
  sortedItems: string[];
  prevType: any;
}

const initialState: ThresholdFormsState = {
  forms: [],
  deleteCandidate: undefined,
  selectedForm: undefined,
  saveIsDisabled: true,
  sortedItems: [],
  prevType: undefined,
};

export const thresholdFormsSlice = createSlice({
  name: 'thresholdForms',
  initialState,
  reducers: {
    setForms: (state, action: PayloadAction<ThresholdFormType[]>) => {
      state.forms = action.payload;
    },
    setThresholdDeleteCandidate: (state, action: PayloadAction<ThresholdFormType>) => {
      state.deleteCandidate = action.payload;
    },
    setSelectedForm: (state, action: PayloadAction<ThresholdFormType>) => {
      state.selectedForm = action.payload;
    },
    setSaveIsDisabled: (state, action: PayloadAction<boolean>) => {
      state.saveIsDisabled = action.payload;
    },
    setSortedItems: (state, action: PayloadAction<string[]>) => {
      state.sortedItems = action.payload;
    },
    setPrevType: (state, action: PayloadAction<any>) => {
      state.prevType = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setPrevType,
  setSortedItems,
  setSaveIsDisabled,
  setForms,
  setThresholdDeleteCandidate,
  setSelectedForm,
} = thresholdFormsSlice.actions;

export default thresholdFormsSlice.reducer;
